// The one file a branded build changes. Everything else reads these values.
export const theme = {
  productName: "DevFusion Workspace",
  logo: { light: "/brand/logo-color-web-v1.webp", dark: "/brand/logo-white-web-v1.webp", mark: "/brand/icon-192.png", width: 560, height: 185 },
  primary: "#8B3FC7", // light primary; dark primary and the 50..900 scale are derived and contrast-checked at build time
  primaryDark: "#A855F7",
  font: { ui: "Inter", brand: "Outfit" },
  defaultTimezone: "Asia/Karachi",
} as const;

export type Theme = typeof theme;
